import {
  AnalyticsApi,
  AnalyticsEvent,
  IdentityApi,
} from '@backstage/core-plugin-api';
import { Config } from '@backstage/config';

const getPagePath = () => window.location.pathname;

const getReferrer = () => document.referrer;

export class DxAnalyticsClient implements AnalyticsApi {
  public static new(
    config: Config,
    identityApi: IdentityApi,
  ): DxAnalyticsClient {
    const dxConfig = config.getConfig('app.analytics.dx');
    const apiToken = dxConfig.getString('apiToken');
    const enabled = dxConfig.getOptionalBoolean('enabled') ?? false;
    return new DxAnalyticsClient(apiToken, enabled, identityApi);
  }

  private userEmail?: string;
  private readonly initPromise: Promise<void>;

  private constructor(
    private readonly apiToken: string,
    private readonly enabled: boolean,
    identityApi: IdentityApi,
  ) {
    this.initPromise = identityApi
      .getProfileInfo()
      .then(profile => {
        this.userEmail = profile.email;
      })
      .catch(() => {
        // identity unavailable — events will be skipped
      });
  }

  public async captureEvent(event: AnalyticsEvent): Promise<void> {
    if (!this.enabled || event.action !== 'navigate') {
      return;
    }
    await this.initPromise;
    if (!this.userEmail) {
      return;
    }
    const timestamp = Math.floor(Date.now() / 1000).toString();
    const page = getPagePath();
    const referrer = getReferrer();
    const body: Record<string, unknown> = {
      name: 'page.visit',
      email: this.userEmail,
      timestamp,
      metadata: {
        page,
        ...(referrer ? { referrer } : {}),
      },
    };

    fetch('https://api.getdx.com/events.track', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.apiToken}`,
      },
      body: JSON.stringify(body),
    }).catch(() => {
      // fire-and-forget — do not surface DX errors to the user
    });
  }
}
